import store from "@/store";
import {
  ROLE_SUPERUSER,
  GROUP_SUPERUSER,
  ROLE_PARTNER,
  ROLE_SUPER_ADMIN_ORGANIZATION,
  ROLE_FINANCEIRO_VER_COBRANCAS,
  ROLE_VER_CATALOGOS,
  ROLE_VER_ALUNOS_ATIVOS
} from "@/common/config";

export const hasRole = role => {
  return store.getters["user/accessRole"](role);
};

export const hasGroup = role => {
  return store.getters["user/hasAccessGroup"](role);
};

export const canAccessAs = roles => {
  const returnToSafety = { name: "home" };
  let ret = {};

  if (hasRole(ROLE_SUPERUSER)) {
    return hasGroup(GROUP_SUPERUSER) ? ret : returnToSafety;
  }

  if (typeof roles === "string") {
    return hasRole(roles) ? ret : returnToSafety;
  }

  if (!Array.isArray(roles)) {
    throw new Error("canAccessAs: O tipo do parâmetro é inválido.");
  }

  for (let i = 0; i < roles.length; i++) {
    if (!hasRole(roles[i])) {
      return returnToSafety;
    }
  }

  return ret;
};

export const routes = [
  //TODO: As rotas de relatorio USO MENSAL e ROYALTIES podem ser mergeadas em um dashboard de relatorios que
  //libera acesso aos relatorios baseado na role do usuario, se for superuser acesso a ambos, se for partner
  //acessa somente ROYALTIES, porém é melhor esperar ate que tenhamos mais relatorios para não fazer uma
  //tela muito redundante.
  //PS: Observar a tela AmbienteInstituicao.vue, que utiliza uma forma para renderizar os cards e liberar acesso
  //aos mesmos dinamicamente baseado na ROLE
  {
    name: "relatorio-uso-mensal-impressao",
    path: "/relatorios/impressao/uso-mensal",
    meta: {
      icon: "mdi-file-document"
    },
    component: () => import("@/views/RelatorioUsoMensalRaw"),
    props: true,
    beforeEnter: (to, from, next) => {
      next(canAccessAs(ROLE_SUPERUSER));
    }
  },
  {
    name: "index",
    path: "/",
    component: () => import("@/components/layouts/LayoutDefault"),
    meta: {
      icon: ""
    },
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          toolbarTitle: "Início",
          role: "ALL",
          hideHistory: true,
          title: "Início",
          icon: "mdi-home",
          breadcrumbs: [{ text: "Início", to: "/home" }]
        },
        component: () => import("@/views/HomeDefault")
      },
      {
        path: "/superuser",
        name: "home-superuser",
        props: route => ({ isFromSuperUserIcon: true }),
        meta: {
          toolbarTitle: "Administração",
          role: ROLE_SUPERUSER,
          hideHistory: true,
          title: "Administração",
          icon: "mdi-crown",
          breadcrumbs: [{ text: "Início", to: "/home" }]
        },
        component: () => import("@/views/HomeDefault"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_SUPERUSER));
        }
      },
      {
        path: "listagem-disciplinas",
        name: "listagem-disciplinas",
        meta: {
          toolbarTitle: "Listagem de disciplinas",
          role: "ALL",
          hidden: true,
          hideHistory: true,
          title: "Catálogo de disciplinas",
          icon: "mdi-book-open-page-variant",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Dashboard de catálogos", to: "/catalogo-dashboard" },
            { text: "Catálogo de disciplinas", to: "listagem-disciplinas" }
          ]
        },
        component: () => import("@/views/CatalogoDisciplinasPage")
      },
      {
        path: "/educaspace",
        name: "educaspace",
        props: route => ({ isEducaspaceFiltro: true }),
        meta: {
          toolbarTitle: "Listagem de disciplinas",
          role: "ALL",
          hidden: true,
          hideHistory: true,
          title: "Catálogo de disciplinas",
          icon: "mdi-book-open-page-variant",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Dashboard de catálogos", to: "/catalogo-dashboard" },
            { text: "Catálogo de disciplinas", to: "listagem-disciplinas" }
          ]
        },
        component: () => import("@/views/CatalogoDisciplinasPage"),
        
      },
      {
        path: "/catalogo",
        name: "catalogo",
        meta: {
          toolbarTitle: "Catálogos",
          role: "ALL",
          hideHistory: true,
          title: "Catálogos",
          icon: "mdi-book-open-page-variant",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Dashboard de catálogos", to: "/catalogo-dashboard" }
          ]
        },
        component: () => import("@/views/CatalogoDashboard")
      },
      {
        path: "/curso",
        name: "curso",
        meta: {
          toolbarTitle: "Listagem de cursos",
          role: "ALL",
          hideHistory: true,
          hidden: true,
          title: "Cursos",
          icon: "mdi-book-open-page-variant",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Dashboard de catálogos", to: "/catalogo-dashboard" },
            { text: "Catálogo de cursos" }
          ]
        },
        component: () => import("@/views/CatalogoCursosPage")
      },
      {
        path: "/ambiente/instituicao",
        name: "ambiente-instituicao",
        meta: {
          toolbarTitle: "Minha instituição",
          role: "ALL",
          hideHistory: true,
          props: true,
          title: "Minha instituição",
          icon: "mdi-book",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Minha instituição", to: "/ambiente/instituicao" }
          ]
        },
        component: () => import("@/views/AmbienteInstituicao")
      },
      {
        path: "/ambiente/instituicao/arquivo-geral",
        name: "arquivoGeral",
        meta: {
          toolbarTitle: "Listagem de arquivos",
          role: "ALL",
          hideHistory: true,
          title: "Arquivos gerais",
          hidden: true,
          icon: "mdi-book",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Minha instituição", to: "/ambiente/instituicao" },
            { text: "Arquivos gerais" }
          ]
        },
        component: () => import("@/views/ArquivoGeralPage")
      },
      {
        path: "ambiente/instituicao/usuarios",
        name: "usuarios",
        meta: {
          toolbarTitle: "Usuários",
          role: ROLE_SUPER_ADMIN_ORGANIZATION,
          hideHistory: true,
          title: "Usuários",
          hidden: true,
          icon: "mdi-account-group",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Minha instituição", to: "/ambiente/instituicao" },
            { text: "Usuários" }
          ]
        },
        component: () => import("@/views/UsuariosList"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_SUPER_ADMIN_ORGANIZATION));
        }
      },
      {
        path: "ambiente/instituicao/usuario/:id?",
        name: "usuarioItem",
        meta: {
          toolbarTitle: "Cadastro de usuário",
          role: ROLE_SUPER_ADMIN_ORGANIZATION,
          hideHistory: true,
          title: "Cadastro de usuário",
          hidden: true,
          icon: "mdi-cog",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Minha instituição", to: "/ambiente/instituicao" },
            { text: "Usuários", to: "/ambiente/instituicao/usuarios" },
            { text: "Cadastrar usuário" }
          ]
        },
        component: () => import("@/components/editarUsuario/editarUsuario.vue"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_SUPER_ADMIN_ORGANIZATION));
        }
      },
      {
        path: "/mydisciplines",
        name: "mydisciplines",
        meta: {
          toolbarTitle: "Minhas disciplinas",
          role: "ALL",
          hideHistory: true,
          hidden: true,
          props: true,
          title: "Minhas disciplinas",
          icon: "mdi-book",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Minha instituição", to: "/ambiente/instituicao" },
            { text: "Minhas disciplinas" }
          ]
        },
        component: () => import("@/views/MyDisciplines")
      },
      {
        path: "/alunos-ativos",
        name: "alunosAtivo",
        meta: {
          toolbarTitle: "Listagem de acessos",
          role: "ALL",
          hideHistory: true,
          hidden: true,
          title: "Alunos ativos",
          icon: "mdi-account-check",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Acessos", to: "/alunos-ativos" }
          ]
        },
        component: () => import("@/views/AlunoAtivo"),
        beforeEnter: (to, from, next) => {
          // Tela compartilhada entre cliente e superuser. O cliente entra pela
          // permissão de ver alunos ativos; o superuser entra sempre, inclusive
          // quando está no grupo de um cliente — é a própria tela que decide
          // quais controles mostrar, pelo `isSuperUser`.
          if (hasRole(ROLE_SUPERUSER) || hasRole(ROLE_VER_ALUNOS_ATIVOS)) {
            return next();
          }
          next(canAccessAs(ROLE_VER_ALUNOS_ATIVOS));
        }
      },
      {
        path: "/cobrancas",
        name: "cobrancas",
        meta: {
          toolbarTitle: "Cobranças",
          role: "ALL",
          hidden: true,
          hideHistory: true,
          title: "Cobranças",
          icon: "mdi-wallet",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Cobranças", to: "/mycobrancas" }
          ]
        },
        component: () => import("@/views/MyCobrancas"),
        beforeEnter: (to, from, next) => {
          //next(canAccessAs("financeiro.cobrancas.read"));
          next(canAccessAs(ROLE_FINANCEIRO_VER_COBRANCAS));
        }
      },
      {
        path: "/faq",
        name: "faq",
        meta: {
          toolbarTitle: "Dúvidas Frequentes",
          role: "ALL",
          hideHistory: true,
          title: "Dúvidas Frequentes",
          icon: "mdi-help-circle",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "FAQ", to: "/faq" }
          ]
        },
        component: () => import("@/views/FAQPage")
      },

      // {
      //   path: "/financeiro-dashboard",
      //   name: "financeiro",
      //   meta: {
      //     toolbarTitle: "Financeiro",
      //     hideHistory: true,
      //     title: "Financeiro Dashboard",
      //     breadcrumbs: [
      //       { text: "Início", to: "/" },
      //       { text: "Financeiro", to: "/financeiro-dashboard" }
      //     ]
      //   },
      //   component: () => import("@/views/FinanceiroDashboard")
      // },

      //Royalties da organização vai ser implementado futuramente
      {
        path: "/royalties",
        name: "royalties",
        meta: {
          toolbarTitle: "Royalties",
          hideHistory: true,
          role: ROLE_PARTNER && ROLE_SUPERUSER,
          title: "Relatório de valores a receber",
          hidden: true,
          icon: "mdi-file-document",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Royalties", to: "/royalties" }
          ]
        },
        component: () => import("@/views/RoyaltiesPartner"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_PARTNER) || canAccessAs(ROLE_SUPERUSER));
        }
      },
      {
        path: "/fornecedor/:id?",
        name: "fornecedorItem",
        meta: {
          toolbarTitle: "Cadastro de fornecedor",
          role: ROLE_SUPERUSER,
          hidden: true,
          hideHistory: true,
          title: "Cadastrar fornecedor",
          icon: "mdi-account-tie",
          addNew: {
            routeName: "fornecedorItem"
          },
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "fornecedores", to: "/royalties" },
            { text: "Cadastrar fornecedor" }
          ]
        },
        component: () => import("@/views/FornecedorEditPage"),
        beforeEnter(to, from, next) {
          next(canAccessAs(ROLE_SUPERUSER));
        }
      },
      {
        path: "/relatorios/uso-mensal",
        name: "relatorio-uso-mensal",
        meta: {
          toolbarTitle: "Relatorio Uso Mensal",
          role: ROLE_SUPERUSER,
          hideHistory: true,
          title: "Relatorio Uso Mensal",
          hidden: true,
          icon: "mdi-file-document",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Relatorio Uso Mensal", to: "/relatorios/uso-mensal" }
          ]
        },
        component: () => import("@/views/RelatorioUsoMensal"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_SUPERUSER));
        }
      },

      {
        path: "/area-ti",
        name: "area-ti",
        meta: {
          toolbarTitle: "Área TI",
          role: ROLE_SUPERUSER,
          hideHistory: true,
          hidden: true,
          title: "Área TI",
          icon: "mdi-file-document",
          breadcrumbs: [{ text: "Início", to: "/" }, { text: "Área TI" }]
        },
        component: () => import("@/views/AreaTI"),
        beforeEnter: (to, from, next) => {
          //next(canAccessAs("catalogos.read"));
          next(canAccessAs(ROLE_SUPERUSER));
        }
      },
      {
        path: "/leads",
        name: "leads",
        meta: {
          toolbarTitle: "Leads",
          role: ROLE_SUPERUSER,
          hideHistory: true,
          hidden: true,
          title: "Leads",
          icon: "mdi-file-document",
          breadcrumbs: [{ text: "Início", to: "/" }, { text: "Leads" }]
        },
        component: () => import("@/views/LeadsPage"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_SUPERUSER));
        }
      },

      {
        path: "/organizacao/:id?",
        name: "organizacaoItem",
        meta: {
          toolbarTitle: "Cadastro de organização",
          role: ROLE_SUPERUSER,
          hideHistory: true,
          title: "Cadastro de organização",
          hidden: true,
          icon: "mdi-cog",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Organizações", to: "/organizacoes" },
            { text: "Cadastrar organização", to: "/organizacao" }
          ]
        },
        component: () => import("@/views/OrganizationEdit"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_SUPERUSER));
        }
      },
      {
        path: "/organizacoes",
        name: "organizacoes",
        meta: {
          toolbarTitle: "Listagem de organizações",
          role: ROLE_SUPERUSER,
          hideHistory: true,
          title: "Organizações",
          hidden: true,
          icon: "mdi-account-group",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Organizações", to: "/organizacoes" }
          ]
        },
        component: () => import("@/views/OrganizationListPage"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_SUPERUSER));
        }
      },
      {
        path: "/nivel-acesso/:id?",
        name: "nivelAcessoItem",
        meta: {
          toolbarTitle: "Administração de níveis de acesso",
          role: ROLE_SUPER_ADMIN_ORGANIZATION,
          hideHistory: true,
          title: "Administração de níveis de acesso",
          hidden: true,
          icon: "mdi-cog",
          breadcrumbs: [
            { text: "Início", to: "/" },
            { text: "Usuários", to: "/usuarios" },
            { text: "Cadastrar nível de acesso" }
          ]
        },
        component: () => import("@/views/RolesEdit"),
        beforeEnter: (to, from, next) => {
          next(canAccessAs(ROLE_SUPER_ADMIN_ORGANIZATION));
        }
      }
    ]
  },

  {
    path: "/:catchAll(.*)",
    redirect: "/"
  }
];
